const MODULE_PREFIX = 'global/memberships';

export default {
    SET_MEMBERSHIPS: `${MODULE_PREFIX}/SET_MEMBERSHIPS`,
};
